import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';

@Injectable()
export class SettingsEffects {
	constructor(private actions$: Actions) {}
}
